<template>
  <modal-dialog
    ref="modalTarget"
    heading-icon="trash"
    heading="Delete reservation"
    subheading="Are you sure you want to delete this reservation?"
    color="error"
    :has-opener="false"
  >
    <template #primary-action>
      <button
        class="btn btn-error"
        @click="handleDelete"
        :disabled="isPending"
      >
        Delete reservation
      </button>
    </template>
  </modal-dialog>
</template>

<script setup>
import { ref } from 'vue';
import { useDeleteReservation } from '@/services/reservations/queries';

const props = defineProps({
  statementId: {
    type: String,
    required: true,
    default: '',
  },
  reservationId: {
    type: String,
    required: true,
    default: '',
  },
});

const emit = defineEmits(['delete:success']);

const { mutate: deleteReservation, isPending } = useDeleteReservation();

const modalTarget = ref(null);

const showModal = () => {
  modalTarget.value?.showModal();
};

const handleDelete = () => {
  deleteReservation(
    { id: props.reservationId, statement_id: props.statementId },
    {
      onSuccess: () => {
        modalTarget.value?.closeModal();
        emit('delete:success');
      },
    }
  );
};

defineExpose({
  showModal,
});
</script>
